import { render, staticRenderFns } from "./coursetypes.vue?vue&type=template&id=c209c874&scoped=true&"
import script from "./coursetypes.vue?vue&type=script&lang=js&"
export * from "./coursetypes.vue?vue&type=script&lang=js&"
import style0 from "./coursetypes.vue?vue&type=style&index=0&id=c209c874&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c209c874",
  null
  
)

export default component.exports